"use-strict";
var BlsLazyloadImg = (function () {
  return {
    init: function () {
      this.lazyReady();
    },
    lazyReady: function () {
      if (!!window.IntersectionObserver) {
        let observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const onImageLoad = (e) => {
                  const target = e.currentTarget;
                  setTimeout(() => {
                    target
                      ?.closest("motion-element")
                      ?.classList.remove("bls-loading-image");
                    target?.classList.remove("bls-loading-image");
                  }, 600);
                  e.currentTarget.removeEventListener("load", onImageLoad);
                };
                entry.target.width = entry.boundingClientRect.width;
                entry.target.height = entry.boundingClientRect.height;
                entry.target.sizes = `${entry.boundingClientRect.width}px`;
                entry.target.addEventListener("load", onImageLoad);
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: "10px" }
        );
        document.querySelectorAll(".bls-image-js img").forEach((img) => {
          observer.observe(img);
        });
      }
    },
  };
})();
BlsLazyloadImg.init();
function CloseAllPopup(data) {
  publish("closeCanvas", data);
}

const imageReady = (imageOrArray) => {
  if (!imageOrArray) {
    return Promise.resolve();
  }
  imageOrArray =
    imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
  return Promise.all(
    imageOrArray.map((image) => {
      return new Promise((resolve) => {
        if (
          (image.tagName === "IMG" && image.complete) ||
          !image.offsetParent
        ) {
          setTimeout(() => {
            image
              .closest("motion-element")
              ?.classList.remove("bls-loading-image");
            image.classList.remove("bls-loading-image");
            resolve();
          }, 100);
        } else {
          image.addEventListener("load", (e) => {
            e.currentTarget
              .closest("motion-element")
              ?.classList.remove("bls-loading-image");
            e.currentTarget.classList.remove("bls-loading-image");
            resolve();
          });
        }
      });
    })
  );
};

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
class SlideSection extends HTMLElement {
  constructor() {
    super();
    this.globalSlide = null;
    this.init();
  }

  init() {
    if (document.body.classList.contains("index")) {
      let pos = window.pageYOffset;
      if (pos > 0 || document.body.classList.contains("swiper-lazy")) {
        this.initSlide();
      } else {
        if (this.classList.contains("lazy-loading-swiper-before")) {
          this.initSlide();
        } else {
          this.classList.add("lazy-loading-swiper-after");
        }
      }
    } else {
      this.initSlide();
    }
  }

  initSlide() {
    const _this = this;
    var autoplaying = _this?.dataset.autoplay === "true";
    const loop = _this?.dataset.loop === "true";
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const progressbar = _this?.dataset.paginationProgressbar === "true";
    const autoItem = _this?.dataset.itemMobile === "true";
    const autoHeight = _this?.dataset.autoHeight === "true";
    const paginationCustom = _this?.dataset.customPagination;
    const slideShow = _this?.dataset.slideshow === "true";
    const revealSlideshow = _this?.dataset.revealSlideshow === "true";
    const centeredSlidesAttr = _this?.dataset.centeredSlides;
    const centeredSlidesSetting =
      centeredSlidesAttr === undefined
        ? slideShow && parseFloat(itemDesktop) === 1.5
        : centeredSlidesAttr === "true";
    const customNavigation = _this?.dataset.customNavigation === "true";
    const customPrev = _this?.dataset.customPrev;
    const customNext = _this?.dataset.customNext;
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    if (direction == "vertical") {
      _this.style.maxHeight = _this.offsetHeight + "px";
    }
    this.globalSlide = new Swiper(_this, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      autoHeight: autoHeight,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grabCursor: true,
      centeredSlides: centeredSlidesSetting,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: customNavigation ? document.querySelector(`.${customNext}`) : _this.querySelector(".swiper-button-next"),
        prevEl: customNavigation ? document.querySelector(`.${customPrev}`) : _this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el: paginationCustom == undefined ? 
          _this.querySelector(".parent-pagination") ||
          _this.querySelector(".swiper-pagination") : _this.querySelector(`.${paginationCustom}`),
        type: progressbar ? "progressbar" : "bullets",
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
          type: progressbar ? "progressbar" : "bullets",
          autoHeight: false,
          centeredSlides: false
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
          type: progressbar ? "progressbar" : "bullets",
          autoHeight: false,
          centeredSlides: centeredSlidesSetting,
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function (e) {
          var sec__tiktok = _this.closest(".sec__tiktok-video");
          e.autoplay.stop();
          if (_this?.dataset.autoplay === "true") {
            Motion.inView(
              _this,
              async () => {
                e.autoplay.start();
              },
              { margin: "0px 0px -50px 0px" }
            );
          }

          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok);
            window.addEventListener("resize", function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok);
              }, 150);
            });
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
          var video = _this.querySelector("video.slideshow");
          if (video) {
            const handleIntersection = (entries, observer) => {
              if (!entries[0].isIntersecting) return;
              observer.unobserve(_this);
              const videos = _this.querySelectorAll("video");
              videos.forEach((video) => {
                const dataSrc = video.dataset.src;
                if (dataSrc) {
                  video.src = dataSrc;
                  video.removeAttribute("data-src");
                }
              });
            };
            new IntersectionObserver(handleIntersection.bind(_this), {
              rootMargin: "0px 0px 200px 0px",
            }).observe(_this);
          }
        },
        slideChange: function () {
          const index_currentSlide = this.realIndex + 1;
          if (_this.closest(".sec__testimonials-single")) {
            const allDots = _this
              .closest(".sec__testimonials-single")
              .querySelectorAll(`single-item`);
            allDots.forEach((dot) => {
              dot.classList.remove("active");
            });
            _this
              .closest(".sec__testimonials-single")
              .querySelector(
                ".testimonials-author-image[data-position='" +
                  index_currentSlide +
                  "']"
              )
              .classList.add("active");
          }
        },
        slideChangeTransitionStart: function () {
          if (!slideShow) return;
          const currentSlide = this.slides[this.activeIndex];
          currentSlide
            .querySelectorAll("motion-element")
            .forEach(async (motion) => {
              await motion.preInitialize();
            });
        },
        slideChangeTransitionEnd: function () {
          if (!slideShow) return;
          const currentSlide = this.slides[this.activeIndex];
          currentSlide
            .querySelectorAll("motion-element")
            .forEach(async (motion) => {
                motion.classList.remove("animate-delay"),
                await motion.initialize();
            });
        },
        afterInit: function () {
          if (slideShow && revealSlideshow && itemDesktop <= 3) {
            _this.duplicateSlides(this);
          }
        },
        touchMove: function (swiper, event) {
          const innerWidth = event.view.innerWidth;
          const swiperMedia = swiper.el.classList.contains('swiper-popup-media');
          const slidePopup = document.querySelector("slide-section-popup");
          if (slidePopup && swiperMedia && innerWidth > 767) {
            slidePopup.swiper.allowTouchMove = false;
            slidePopup.swiper.unsetGrabCursor();
          }
        },
        touchEnd: function (swiper, event) {
          const innerWidth = event.view.innerWidth;
          const swiperMedia = swiper.el.classList.contains('swiper-popup-media');
          const slidePopup = document.querySelector("slide-section-popup");
          if (!swiperMedia) return;
          if (slidePopup && innerWidth > 767) {
            slidePopup.swiper.allowTouchMove = true;
            slidePopup.swiper.setGrabCursor();
          }
        }
      },
    });
  }

  duplicateSlides(swiper) {
    const _this = this;
    const swiperWrapper = _this.querySelector('.swiper-wrapper');
    const originalSlides = swiperWrapper.querySelectorAll('.swiper-slide');
    const paginationEl = _this.querySelector('.swiper-pagination');
    
    if (paginationEl) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1 && node.classList.contains('swiper-pagination-bullet')) {
                const allBullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
                const bulletIndex = Array.from(allBullets).indexOf(node);
                if (bulletIndex >= originalSlides.length) {
                  node.classList.add('swiper-pagination-duplicate');
                }
              }
            });
          }
        });
        observer.disconnect();
      });
      
      observer.observe(paginationEl, { childList: true });
    }
    
    originalSlides.forEach((slide) => {
        const clonedSlide = slide.cloneNode(true);
        clonedSlide.classList.add('swiper-slide-duplicate');
        swiperWrapper.appendChild(clonedSlide);
    });
    
    swiper.update();
  }

  initSecTiktok(sec) {
    sec.querySelectorAll(".swiper-slide").forEach((arrow) => {
      const tiktok = arrow.querySelector(".section_tiktok-image");
      let width = "--item-width: " + arrow.offsetWidth;
      tiktok.setAttribute("style", width);
    });
  }
}
customElements.define("slide-section", SlideSection);

class PopupBase extends HTMLElement {
  constructor() {
    super();
    this.customClass = this.dataset.customClass;
    this.modal = null;
  }

  initPopup(content, text, customClass, modalWidth) {
    const _this = this;
    this.modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ["overlay", "button", "escape"],
      cssClass: [this.customClass || customClass],
      onOpen: function () {
        const modalBoxContent = this.modal.querySelector(".tingle-modal-box");
        if (modalWidth) {
          modalBoxContent.style.setProperty("--popup-max-width", modalWidth);
        }
        document.dispatchEvent(new CustomEvent("modal:opened"));
        document.documentElement.classList.add("open-popup");
        root.style.setProperty(
          "padding-right",
          getScrollBarWidth.init() + "px"
        );
        const video = this.modalBox.querySelector("video");
        if (!video) return;
        video.play();
        if (this.modal.classList.contains("shopable-video")) {
          video.muted = false;
        }
      },
      onClose: function () {
        document.dispatchEvent(new CustomEvent("modal:closed"));
        document.documentElement.classList.remove("open-popup");
        root.style.removeProperty("padding-right");
      },
      beforeClose: function () {
        _this.onCloseEvent();
        document.documentElement.classList.remove("open-popup");
        root.style.removeProperty("padding-right");
        return true;
      },
    });
    this.modal.setHeader = function (content) {
      let popup_content = this.modalBoxContent;
      let popup_header = document.createElement("div");
      popup_header.classList.add("tingle-modal-box__header");
      popup_header.innerHTML = content;
      let parentElement = popup_content.parentNode;
      parentElement.insertBefore(popup_header, popup_content);
    };
    if (text) {
      this.modal.setHeader(text);
    }

    this.modal.setContent(content);
    this.modal.open();
  }

  onClose() {
    this.modal.close();
  }
  onCloseEvent() {}
}

class SwatchInit extends HTMLElement {
  constructor() {
    super();
    this.options = null;
    this.init();
  }

  init() {
    const _this = this;
    this.querySelectorAll(".product__color-swatches--js").forEach((btn) => {
      _this.checkSwatches(btn);
    });
  }
  checkSwatches(e) {
    const { color, image, customValue, swatchType, optionSwatchValue } =
      e.dataset;
    if (color) {
      if (swatchType != "variant_images") {
        if (optionSwatchValue.length == 0 || optionSwatchValue == null) {
          if (this.checkColor(color)) {
            e.style.backgroundColor = color;
            e.classList.add(customValue);
          } else {
            e.classList.add(customValue);
            if (image) {
              e.classList.add("color__" + color.replace(" ", "-"));
              e.style.backgroundColor = null;
              e.style.backgroundImage = "url('" + image + "')";
              e.style.backgroundSize = "cover";
              e.style.backgroundRepeat = "no-repeat";
            }
          }
        } else {
          e.style.setProperty("--swatch--background", optionSwatchValue);
        }
      } else {
        if (optionSwatchValue == null || optionSwatchValue.length == 0) {
          if (image) {
            e.classList.add("color__" + color.replace(" ", "-"));
            e.style.backgroundColor = null;
            e.style.backgroundImage = "url('" + image + "')";
            e.style.backgroundSize = "cover";
            e.style.backgroundRepeat = "no-repeat";
          } else if (this.checkColor(color)) {
            e.style.backgroundColor = color;
            e.classList.add(customValue);
          } else {
            e.classList.add(customValue);
          }
        } else {
          e.style.setProperty("--swatch--background", optionSwatchValue);
        }
      }
    }
  }
  checkColor(strColor) {
    var s = new Option().style;
    s.color = strColor;
    return s.color == strColor;
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll(".product__color-swatches--js.active"),
      (select) => select.getAttribute("data-value")
    );
    this.variantData.find((variant) => {
      if (this.options.length == 1) {
        const variantOptions = {
          1: variant.option1,
          2: variant.option2,
          3: variant.option3,
        };
        if (variantOptions[this.position_swatch] === this.options[0]) {
          this.options = variant.options;
        }
      }
    });
  }
  updateMasterId(variantData) {
    return (this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    }));
  }
}

// js for 3d product - not done yet
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        deferredElement.play();
      }
    }
  }
}

function handleErrorMessagePopup(errorMessage = false) {
  const url = `${window.location.pathname}?section_id=form-message`;
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const elementErrorMessage = html.querySelector(
        ".product-form__error-message-wrapper"
      );
      const elementMessage = elementErrorMessage.querySelector(
        ".product-form__error-message"
      );
      elementMessage.textContent = errorMessage;
      showToast(elementErrorMessage.innerHTML, 5000, "modal-error");
    })
    .catch((e) => {
      throw e;
    });
}

function showToast(message, duration = 3000, customClass = "") {
  let toastContainer = document.getElementById("toast-container");
  if (!toastContainer) {
    toastContainer = document.createElement("div");
    toastContainer.id = "toast-container";
    document.body.appendChild(toastContainer);
  }

  const toast = document.createElement("div");
  toast.className = `toast show ${customClass}`;
  toast.innerHTML = message;
  toastContainer.appendChild(toast);

  Motion.animate(
    toast,
    {
      opacity: [0, 1],
      scale: [0.3, 1],
    },
    {
      duration: 0.3,
      easing: "ease-out",
    }
  );

  setTimeout(() => {
    closeToast(toast);
  }, duration);
}

function closeToast(toast) {
  Motion.animate(
    toast,
    { opacity: 0, scale: 0.5 },
    { duration: 0.2, easing: "ease-in" }
  ).then(() => {
    toast.remove();
  });
}

class SlideLazyLoad {
  constructor(e) {
    (this.triggerEventsJs = e),
      (this.eventOptionsJs = { passive: !0 }),
      (this.userEventListenerJs = this.triggerListenerJs.bind(this)),
      (this.delayedScriptsJs = { normal: [], async: [], defer: [] });
  }
  triggerListenerJs() {
    this._removeUserInteractionListenerJs(this),
      "loading" === document.readyState
        ? document.addEventListener(
            "DOMContentLoaded",
            this._loadEverythingReadyNow.bind(this)
          )
        : this._loadEverythingReadyNow();
  }
  _removeUserInteractionListenerJs(e) {
    this.triggerEventsJs.forEach((t) =>
      window.removeEventListener(t, e.userEventListenerJs, e.eventOptionsJs)
    );
  }
  _addUserInteractionListenerJs(e) {
    this.triggerEventsJs.forEach((t) =>
      window.addEventListener(t, e.userEventListenerJs, e.eventOptionsJs)
    );
  }
  _preloadAllScriptsJs() {
    document.body.classList.add("swiper-lazy");
    document.body.classList.add("review-lazy");
    const loadingSwiper = document.querySelectorAll(
      ".lazy-loading-swiper-after"
    );
    loadingSwiper.forEach((el) => {
      el.classList.remove("lazy-loading-swiper-after");
      this.initSlide(el);
    });
    const reviewProduct = document.querySelectorAll(".review-product-added");
    reviewProduct.forEach((el) => {
      el.classList.remove("review-product-added");
      el.innerHTML = el.querySelector(".product-review-json").innerHTML;
      el.classList.remove("inline-loading");
    });
  }

  initSlide(el) {
    const _this = el;
    var autoplaying = _this?.dataset.autoplay === "true";
    const loop = _this?.dataset.loop === "true";
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const progressbar = _this?.dataset.paginationProgressbar === "true";
    const autoItem = _this?.dataset.itemMobile === "true";
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    if (direction == "vertical") {
      _this.style.maxHeight = _this.offsetHeight + "px";
    }
    _this.globalSlide = new Swiper(el, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: _this.querySelector(".swiper-button-next"),
        prevEl: _this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el:
          _this.querySelector(".parent-pagination") ||
          _this.querySelector(".swiper-pagination"),
        type: progressbar ? "progressbar" : "bullets",
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
          pagination: {
            type: progressbar ? "progressbar" : "bullets",
          },
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
          pagination: {
            type: progressbar ? "progressbar" : "bullets",
          },
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function (e) {
          e.autoplay.stop();
          if (_this?.dataset.autoplay === "true") {
            Motion.inView(
              _this,
              async () => {
                e.autoplay.start();
              },
              { margin: "0px 0px -50px 0px" }
            );
          }
          var sec__tiktok = _this.closest(".sec__tiktok-video");
          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok);
            window.addEventListener("resize", function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok);
              }, 150);
            });
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
        },
        realIndexChange: function (swiper) {
          var slide_visibles = _this.querySelectorAll(
            ".swiper-slide motion-element:not([data-image])"
          );
          slide_visibles?.forEach((slide) => {
            if (!slide.hasAttribute("hold")) {
              slide?.setAttribute("hold", true);
            }
          });
        },
        slideChange: function () {
          const index_currentSlide = this.realIndex + 1;
          if (_this.closest(".sec__testimonials-single")) {
            const allDots = _this
              .closest(".sec__testimonials-single")
              .querySelectorAll(`single-item`);
            allDots.forEach((dot) => {
              dot.classList.remove("active");
            });
            _this
              .closest(".sec__testimonials-single")
              .querySelector(
                ".testimonials-author-image[data-position='" +
                  index_currentSlide +
                  "']"
              )
              .classList.add("active");
          }
        },
      },
    });
  }

  async _loadEverythingReadyNow() {
    this._preloadAllScriptsJs(),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.normal),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.defer),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.async),
      await this._triggerDOMContentLoadedJs(),
      await this._triggerWindowLoadJs(),
      window.dispatchEvent(new Event("glozinspeed-allScriptsLoaded"));
  }
  async _loadScriptsFromListJs(e) {
    const t = e.shift();
    return t
      ? (await this._transformScript(t), this._loadScriptsFromListJs(e))
      : Promise.resolve();
  }
  async _transformScript(e) {
    return (
      await this._requestAnimFrame(),
      new Promise((t) => {
        const s = document.createElement("script");
        let n;
        [...e.attributes].forEach((e) => {
          let t = e.nodeName;
          "type" !== t &&
            ("data-glozinlazy-type" === t && ((t = "type"), (n = e.nodeValue)),
            s.setAttribute(t, e.nodeValue));
        }),
          e.hasAttribute("src")
            ? (s.addEventListener("load", t), s.addEventListener("error", t))
            : ((s.text = e.text), t()),
          e.parentNode.replaceChild(s, e);
      })
    );
  }
  async _triggerDOMContentLoadedJs() {
    (this.domReadyFired = !0),
      await this._requestAnimFrame(),
      document.dispatchEvent(new Event("glozinspeed-DOMContentLoaded")),
      await this._requestAnimFrame(),
      window.dispatchEvent(new Event("glozinspeed-DOMContentLoaded")),
      await this._requestAnimFrame(),
      document.dispatchEvent(new Event("glozinspeed-readystatechange")),
      await this._requestAnimFrame(),
      document.glozinonreadystatechange && document.glozinonreadystatechange();
  }
  async _triggerWindowLoadJs() {
    await this._requestAnimFrame(),
      window.dispatchEvent(new Event("glozinspeed-load")),
      await this._requestAnimFrame(),
      window.glozinonload && window.glozinonload(),
      await this._requestAnimFrame(),
      window.dispatchEvent(new Event("glozinspeed-pageshow")),
      await this._requestAnimFrame(),
      window.glozinonpageshow && window.glozinonpageshow();
  }
  async _requestAnimFrame() {
    return new Promise((e) => requestAnimationFrame(e));
  }
  static run() {
    const e = new SlideLazyLoad([
      "keydown",
      "mousemove",
      "touchmove",
      "touchstart",
      "touchend",
      "wheel",
    ]);
    e._addUserInteractionListenerJs(e);
  }
}
SlideLazyLoad.run();

// js for copy button
class CopyButton extends HTMLElement {
  constructor() {
    super();
    this.content = this.dataset.content;
    this.init();
  }
  init() {
    if (this.content) {
      this.addEventListener("click", this.onClick.bind(this));
    }
  }
  onClick() {
    navigator.clipboard.writeText(this.content);
    this.classList.add("copied");
  }
  updateUrl(newContent) {
    this.content = newContent;
  }
}
customElements.define("copy-button", CopyButton);
// Calculadora Pretty Woman: pantalones, leggins y joggers.
(() => {
  if (window.pwCaderaCalculatorInstalled) return;
  window.pwCaderaCalculatorInstalled = true;

  document.addEventListener("input", (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.id !== "pw-cadera") return;

    const calculator = input.closest(".gt-calc");
    const result = calculator?.querySelector(".gt-result");
    if (!result) return;

    result.setAttribute("role", "status");
    result.setAttribute("aria-live", "polite");

    if (input.value.trim() === "") {
      result.textContent = "";
      return;
    }

    const cadera = Number(input.value);
    const tallas = [
      { talla: "S", min: 94, max: 100 },
      { talla: "M", min: 102, max: 108 },
      { talla: "L", min: 110, max: 116 },
      { talla: "XL", min: 118, max: 124 }
    ];

    if (!Number.isFinite(cadera) || cadera <= 0) {
      result.textContent = "Ingresa una medida válida en centímetros.";
      return;
    }

    const match = tallas.find(
      (item) => cadera >= item.min && cadera <= item.max
    );

    result.textContent = match
      ? `Según tu cadera, tu talla es ${match.talla}. Revisa también la cintura en la tabla.`
      : "Tu medida no coincide con los rangos de la tabla. Consúltanos para orientarte.";
  });
})();
// Calculadora de cintura Pretty Woman
(function () {
  if (window.pwCinturaCalculatorInstalled) return;
  window.pwCinturaCalculatorInstalled = true;

  document.addEventListener("input", function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.id !== "pw-cintura") return;

    const calculator = input.closest(".gt-calc");
    if (!calculator) return;

    const result = calculator.querySelector("#pw-cintura-result");
    if (!result) return;

    if (input.value.trim() === "") {
      result.textContent = "";
      return;
    }

    const cintura = Number(input.value);
    const tallas = [
      { talla: "S", min: 64, max: 70 },
      { talla: "M", min: 72, max: 78 },
      { talla: "L", min: 80, max: 86 },
      { talla: "XL", min: 88, max: 94 }
    ];

    if (!Number.isFinite(cintura) || cintura <= 0) {
      result.textContent = "Ingresá una medida válida en centímetros.";
      return;
    }

    const match = tallas.find(function (item) {
      return cintura >= item.min && cintura <= item.max;
    });

    result.textContent = match
      ? "Según tu cintura, tu talla es " + match.talla +
        ". Revisá también tu cadera en la tabla."
      : "Tu medida no coincide con los rangos de la tabla. Consultanos para orientarte.";
  });
})();
// Calculadora Pretty Woman: Jeans
(function () {
  if (window.pwJeansCalculatorInstalled) return;
  window.pwJeansCalculatorInstalled = true;

  const tallas = [
    { talla: "3", cintura: [63, 67], cadera: [85, 89] },
    { talla: "5", cintura: [68, 72], cadera: [90, 94] },
    { talla: "7", cintura: [73, 77], cadera: [95, 99] },
    { talla: "9", cintura: [78, 82], cadera: [100, 104] },
    { talla: "11", cintura: [83, 88], cadera: [105, 109] },
    { talla: "13–15", cintura: [88, 94], cadera: [111, 114] },
    { talla: "15–17", cintura: [95, 100], cadera: [119, 124] },
    { talla: "19", cintura: [101, 106], cadera: [124, 129] },
    { talla: "21", cintura: [107, 113], cadera: [129, 134] },
    { talla: "23", cintura: [114, 120], cadera: [134, 139] },
    { talla: "25", cintura: [121, 126], cadera: [139, 144] }
  ];

  document.addEventListener("input", function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;

    let medida;
    if (input.id === "pw-jeans-cintura") {
      medida = "cintura";
    } else if (input.id === "pw-jeans-cadera") {
      medida = "cadera";
    } else {
      return;
    }

    const calculator = input.closest(".gt-calc");
    if (!calculator) return;

    const result = calculator.querySelector(
      "#pw-jeans-" + medida + "-result"
    );
    if (!result) return;

    if (input.value.trim() === "") {
      result.textContent = "";
      return;
    }

    const valor = Number(input.value);
    if (!Number.isFinite(valor) || valor <= 0) {
      result.textContent = "Ingresá una medida válida en centímetros.";
      return;
    }

    const coincidencias = tallas.filter(function (item) {
      return valor >= item[medida][0] && valor <= item[medida][1];
    });

    if (coincidencias.length === 0) {
      result.textContent =
        "Tu medida no coincide con los rangos de la tabla. Consultanos para orientarte.";
      return;
    }

    const opciones = coincidencias.map(function (item) {
      return item.talla;
    }).join(" o ");

    result.textContent = coincidencias.length > 1
      ? "Según tu " + medida + ", coincidís con las tallas " +
        opciones + ". Revisá ambas medidas; priorizá la cadera."
      : "Según tu " + medida + ", tu talla de jeans es " +
        opciones + ". Revisá también la otra medida en la tabla.";
  });
})();
// Calculadora de busto Pretty Woman
(function () {
  if (window.pwBustoCalculatorInstalled) return;
  window.pwBustoCalculatorInstalled = true;

  document.addEventListener("input", function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.id !== "pw-busto") return;

    const calculator = input.closest(".gt-calc");
    if (!calculator) return;

    const result = calculator.querySelector("#pw-busto-result");
    if (!result) return;

    result.setAttribute("role", "status");
    result.setAttribute("aria-live", "polite");

    if (input.value.trim() === "") {
      result.textContent = "";
      return;
    }

    const busto = Number(input.value);
    const tallas = [
      { talla: "S", numerica: "6", min: 88, max: 92 },
      { talla: "M", numerica: "8", min: 93, max: 97 },
      { talla: "L", numerica: "10", min: 98, max: 102 },
      { talla: "XL", numerica: "12", min: 103, max: 108 }
    ];

    if (!Number.isFinite(busto) || busto <= 0) {
      result.textContent = "Ingresá una medida válida en centímetros.";
      return;
    }

    const match = tallas.find(function (item) {
      return busto >= item.min && busto <= item.max;
    });

    result.textContent = match
      ? "Según tu busto, tu talla es " + match.talla +
        " (talla numérica " + match.numerica + ")."
      : "Tu medida no coincide con los rangos de la tabla. Consultanos para orientarte.";
  });
})();
// Calculadora Pretty Woman: Crop Tops - Tops
(function () {
  if (window.pwPechoCalculatorInstalled) return;
  window.pwPechoCalculatorInstalled = true;

  document.addEventListener("input", function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.id !== "pw-pecho") return;

    const calculator = input.closest(".gt-calc");
    if (!calculator) return;

    const result = calculator.querySelector("#pw-pecho-result");
    if (!result) return;

    result.setAttribute("role", "status");
    result.setAttribute("aria-live", "polite");

    if (input.value.trim() === "") {
      result.textContent = "";
      return;
    }

    const pecho = Number(input.value);
    const tallas = [
      { talla: "S", numerica: "6", min: 88, max: 92 },
      { talla: "M", numerica: "8", min: 93, max: 97 },
      { talla: "L", numerica: "10", min: 98, max: 102 },
      { talla: "XL", numerica: "12", min: 103, max: 108 },
      { talla: "5XL", numerica: "20", min: 127, max: 132 }
    ];

    if (!Number.isFinite(pecho) || pecho <= 0) {
      result.textContent = "Ingresá una medida válida en centímetros.";
      return;
    }

    const match = tallas.find(function (item) {
      return pecho >= item.min && pecho <= item.max;
    });

    result.textContent = match
      ? "Según tu pecho, tu talla es " + match.talla +
        " (talla numérica " + match.numerica + ")."
      : "Tu medida no coincide con los rangos de la tabla. Consultanos para orientarte.";
  });
})();
// Calculadora de busto y cintura: Vestidos y Enterizos
(function () {
  if (window.pwVestidosCalculatorInstalled) return;
  window.pwVestidosCalculatorInstalled = true;

  const tallas = [
    { talla: "S", busto: [82, 88], cintura: [60, 66] },
    { talla: "M", busto: [90, 96], cintura: [68, 74] },
    { talla: "L", busto: [98, 104], cintura: [76, 82] },
    { talla: "XL", busto: [106, 116], cintura: [84, 94] }
  ];

  document.addEventListener("input", function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;

    let medida;
    if (input.id === "pw-vestidos-busto") {
      medida = "busto";
    } else if (input.id === "pw-vestidos-cintura") {
      medida = "cintura";
    } else {
      return;
    }

    const calculator = input.closest(".gt-calc");
    if (!calculator) return;

    const result = calculator.querySelector(
      "#pw-vestidos-" + medida + "-result"
    );
    if (!result) return;

    if (input.value.trim() === "") {
      result.textContent = "";
      return;
    }

    const valor = Number(input.value);
    if (!Number.isFinite(valor) || valor <= 0) {
      result.textContent = "Ingresá una medida válida en centímetros.";
      return;
    }

    const match = tallas.find(function (item) {
      return valor >= item[medida][0] && valor <= item[medida][1];
    });

    result.textContent = match
      ? "Según tu " + medida + ", tu talla es " + match.talla +
        ". Compará también las otras medidas en la tabla."
      : "Tu medida no coincide con los rangos de la tabla. Consultanos para orientarte.";
  });
})();
// Calculadora de base: Brasieres y Tops
(function () {
  if (window.pwBaseCalculatorInstalled) return;
  window.pwBaseCalculatorInstalled = true;

  document.addEventListener("input", function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.id !== "pw-base") return;

    const calculator = input.closest(".gt-calc");
    if (!calculator) return;

    const result = calculator.querySelector("#pw-base-result");
    if (!result) return;

    result.setAttribute("role", "status");
    result.setAttribute("aria-live", "polite");

    if (input.value.trim() === "") {
      result.textContent = "";
      return;
    }

    const base = Number(input.value);
    const tallas = [
      { talla: "32", min: 68, max: 72 },
      { talla: "34", min: 73, max: 77 },
      { talla: "36", min: 78, max: 82 },
      { talla: "38", min: 83, max: 87 },
      { talla: "40", min: 88, max: 92 },
      { talla: "42", min: 93, max: 97 }
    ];

    if (!Number.isFinite(base) || base <= 0) {
      result.textContent = "Ingresá una medida válida en centímetros.";
      return;
    }

    const match = tallas.find(function (item) {
      return base >= item.min && base <= item.max;
    });

    result.textContent = match
      ? "Según tu base, tu talla es " + match.talla +
        ". Revisá también tu busto en la tabla."
      : "Tu medida no coincide con los rangos de la tabla. Consultanos para orientarte.";
  });
})();
// Calculadora de busto: Brasieres y Tops
(function () {
  if (window.pwBrasierBustoInstalled) return;
  window.pwBrasierBustoInstalled = true;

  const tallas = [
    { talla: "32", min: 78, max: 87 },
    { talla: "34", min: 83, max: 92 },
    { talla: "36", min: 88, max: 97 },
    { talla: "38", min: 93, max: 102 },
    { talla: "40", min: 98, max: 107 },
    { talla: "42", min: 103, max: 112 }
  ];

  document.addEventListener("input", function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.id !== "pw-brasier-busto") return;

    const calculator = input.closest(".gt-calc");
    if (!calculator) return;

    const result = calculator.querySelector(
      "#pw-brasier-busto-result"
    );
    if (!result) return;

    if (input.value.trim() === "") {
      result.textContent = "";
      return;
    }

    const busto = Number(input.value);
    if (!Number.isFinite(busto) || busto <= 0) {
      result.textContent = "Ingresá una medida válida en centímetros.";
      return;
    }

    const coincidencias = tallas.filter(function (item) {
      return busto >= item.min && busto <= item.max;
    });

    if (coincidencias.length === 0) {
      result.textContent =
        "Tu medida no coincide con los rangos de la tabla. Consultanos para orientarte.";
      return;
    }

    const opciones = coincidencias.map(function (item) {
      return item.talla;
    }).join(" o ");

    result.textContent =
      "Según tu busto, coincidís con la talla " + opciones +
      ". Compará con el resultado de base para elegir. Este cálculo no determina la copa.";
  });
})();
// Calculadora Chamela: Base y busto
(function () {
  if (window.chmBrasierCalculatorInstalled) return;
  window.chmBrasierCalculatorInstalled = true;

  const tallas = [
    { talla: "30", base: [57, 61], busto: [85, 88] },
    { talla: "32", base: [62, 66], busto: [89, 92] },
    { talla: "34", base: [67, 71], busto: [93, 97] },
    { talla: "36", base: [72, 76], busto: [98, 102] },
    { talla: "38", base: [77, 81], busto: [103, 107] }
  ];

  document.addEventListener("input", function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;

    let medida;
    let resultadoId;

    if (input.id === "chm-base") {
      medida = "base";
      resultadoId = "#chm-base-result";
    } else if (input.id === "chm-brasier-busto") {
      medida = "busto";
      resultadoId = "#chm-brasier-busto-result";
    } else {
      return;
    }

    const calculator = input.closest(".gt-calc");
    if (!calculator) return;

    const result = calculator.querySelector(resultadoId);
    if (!result) return;

    if (input.value.trim() === "") {
      result.textContent = "";
      return;
    }

    const valor = Number(input.value);
    if (!Number.isFinite(valor) || valor <= 0) {
      result.textContent = "Ingresá una medida válida en centímetros.";
      return;
    }

    const match = tallas.find(function (item) {
      return valor >= item[medida][0] && valor <= item[medida][1];
    });

    result.textContent = match
      ? "Según tu " + medida + ", tu talla Chamela es " +
        match.talla + ". Compará también la otra medida en la tabla."
      : "Tu medida no coincide con los rangos de la tabla. Consultanos para orientarte.";
  });
})();
// Calculadora Chamela: Ropa Interior Inferiores
(function () {
  if (window.chmCaderaCalculatorInstalled) return;
  window.chmCaderaCalculatorInstalled = true;

  document.addEventListener("input", function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.id !== "chm-cadera") return;

    const calculator = input.closest(".gt-calc");
    if (!calculator) return;

    const result = calculator.querySelector("#chm-cadera-result");
    if (!result) return;

    result.setAttribute("role", "status");
    result.setAttribute("aria-live", "polite");

    if (input.value.trim() === "") {
      result.textContent = "";
      return;
    }

    const cadera = Number(input.value);
    const tallas = [
      { talla: "S", min: 62, max: 66 },
      { talla: "M", min: 67, max: 71 },
      { talla: "L", min: 72, max: 76 },
      { talla: "XL", min: 77, max: 81 }
    ];

    if (!Number.isFinite(cadera) || cadera <= 0) {
      result.textContent = "Ingresá una medida válida en centímetros.";
      return;
    }

    const match = tallas.find(function (item) {
      return cadera >= item.min && cadera <= item.max;
    });

    result.textContent = match
      ? "Según tu cadera, tu talla Chamela es " + match.talla + "."
      : "Tu medida no coincide con los rangos de la tabla. Consultanos para orientarte.";
  });
})();
// Calculadoras Chamela: Vestidos de Baño
(function () {
  if (window.chmBanoCalculatorsInstalled) return;
  window.chmBanoCalculatorsInstalled = true;

  const top = [
    { talla: "S/32", min: 85, max: 87 },
    { talla: "M/34", min: 90, max: 92 },
    { talla: "L/36", min: 95, max: 97 },
    { talla: "XL/38", min: 100, max: 102 }
  ];

  const panty = [
    { talla: "S/32", min: 95, max: 99 },
    { talla: "M/34", min: 100, max: 104 },
    { talla: "L/36", min: 105, max: 109 },
    { talla: "XL/38", min: 110, max: 114 }
  ];

  document.addEventListener("input", function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;

    let tallas;
    let prenda;

    if (input.id === "chm-top") {
      tallas = top;
      prenda = "top";
    } else if (input.id === "chm-panty") {
      tallas = panty;
      prenda = "panty";
    } else {
      return;
    }

    const calculator = input.closest(".gt-calc");
    if (!calculator) return;

    const result = calculator.querySelector(
      "#" + input.id + "-result"
    );
    if (!result) return;

    result.setAttribute("role", "status");
    result.setAttribute("aria-live", "polite");

    if (input.value.trim() === "") {
      result.textContent = "";
      return;
    }

    const valor = Number(input.value);
    if (!Number.isFinite(valor) || valor <= 0) {
      result.textContent = "Ingresá una medida válida en centímetros.";
      return;
    }

    const match = tallas.find(function (item) {
      return valor >= item.min && valor <= item.max;
    });

    result.textContent = match
      ? "Tu talla Chamela de " + prenda + " es " + match.talla +
        (prenda === "panty"
          ? ". Revisá también tu cintura en la tabla."
          : ".")
      : "Tu medida no coincide con los rangos de la tabla. Consultanos para orientarte.";
  });
})();
// Calculadora Chamela: Cintura de panty de baño
(function () {
  if (window.chmPantyCinturaInstalled) return;
  window.chmPantyCinturaInstalled = true;

  document.addEventListener("input", function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.id !== "chm-panty-cintura") return;

    const calculator = input.closest(".gt-calc");
    if (!calculator) return;

    const result = calculator.querySelector(
      "#chm-panty-cintura-result"
    );
    if (!result) return;

    if (input.value.trim() === "") {
      result.textContent = "";
      return;
    }

    const cintura = Number(input.value);
    const tallas = [
      { talla: "S/32", min: 63, max: 67 },
      { talla: "M/34", min: 69, max: 73 },
      { talla: "L/36", min: 74, max: 79 },
      { talla: "XL/38", min: 80, max: 85 }
    ];

    if (!Number.isFinite(cintura) || cintura <= 0) {
      result.textContent = "Ingresá una medida válida en centímetros.";
      return;
    }

    const match = tallas.find(function (item) {
      return cintura >= item.min && cintura <= item.max;
    });

    result.textContent = match
      ? "Según tu cintura, tu talla de panty es " + match.talla +
        ". Compará también tu cadera en la tabla."
      : "Tu medida no coincide con los rangos de la tabla. Consultanos para orientarte.";
  });
})();
// Calculadora Chamela: Deportiva Inferiores
(function () {
  if (window.chmDeportivaInferioresInstalled) return;
  window.chmDeportivaInferioresInstalled = true;

  const tallas = [
    { talla: "S", alta: [58, 61], cintura: [69, 72], cadera: [93, 97] },
    { talla: "M", alta: [62, 65], cintura: [70, 73], cadera: [98, 102] },
    { talla: "L", alta: [66, 69], cintura: [74, 77], cadera: [103, 107] },
    { talla: "XL", alta: [70, 73], cintura: [78, 81], cadera: [108, 113] }
  ];

  const campos = {
    "chm-deportiva-cintura-alta": {
      medida: "alta",
      nombre: "cintura alta"
    },
    "chm-deportiva-cintura": {
      medida: "cintura",
      nombre: "cintura"
    },
    "chm-deportiva-cadera": {
      medida: "cadera",
      nombre: "cadera"
    }
  };

  document.addEventListener("input", function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (!Object.prototype.hasOwnProperty.call(campos, input.id)) return;

    const campo = campos[input.id];
    const calculator = input.closest(".gt-calc");
    if (!calculator) return;

    const result = calculator.querySelector(
      "#" + input.id + "-result"
    );
    if (!result) return;

    if (input.value.trim() === "") {
      result.textContent = "";
      return;
    }

    const valor = Number(input.value);
    if (!Number.isFinite(valor) || valor <= 0) {
      result.textContent = "Ingresá una medida válida en centímetros.";
      return;
    }

    const coincidencias = tallas.filter(function (item) {
      const rango = item[campo.medida];
      return valor >= rango[0] && valor <= rango[1];
    });

    if (coincidencias.length === 0) {
      result.textContent =
        "Tu medida de " + campo.nombre +
        " no coincide con los rangos de la tabla. Consultanos para orientarte.";
      return;
    }

    const opciones = coincidencias.map(function (item) {
      return item.talla;
    }).join(" o ");

    result.textContent =
      "Según tu " + campo.nombre + ", coincidís con " +
      (coincidencias.length > 1 ? "las tallas " : "la talla ") +
      opciones + ". Compará también las otras medidas en la tabla.";
  });
})();
// Calculadora Chamela: Deportiva Superiores
(function () {
  if (window.chmDeportivaPechoInstalled) return;
  window.chmDeportivaPechoInstalled = true;

  document.addEventListener("input", function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.id !== "chm-pecho") return;

    const calculator = input.closest(".gt-calc");
    if (!calculator) return;

    const result = calculator.querySelector("#chm-pecho-result");
    if (!result) return;

    result.setAttribute("role", "status");
    result.setAttribute("aria-live", "polite");

    if (input.value.trim() === "") {
      result.textContent = "";
      return;
    }

    const pecho = Number(input.value);
    const tallas = [
      { talla: "S", min: 85, max: 88 },
      { talla: "M", min: 89, max: 92 },
      { talla: "L", min: 93, max: 97 },
      { talla: "XL", min: 98, max: 102 }
    ];

    if (!Number.isFinite(pecho) || pecho <= 0) {
      result.textContent = "Ingresá una medida válida en centímetros.";
      return;
    }

    const match = tallas.find(function (item) {
      return pecho >= item.min && pecho <= item.max;
    });

    result.textContent = match
      ? "Según tu contorno de pecho, tu talla Chamela es " +
        match.talla + "."
      : "Tu medida no coincide con los rangos de la tabla. Consultanos para orientarte.";
  });
})();